import { spawn, call, takeLatest, put, all } from 'redux-saga/effects';

// Actions
import { ofertaActions } from '../../../../application/actions/oferta';

import { loadersActions } from '../../../../application/actions/ui_loaders';

// import { logReqError } from '../../../ui/utils/functions';

import api from '../../../api';

const apiOferta = api(process.env.REACT_APP_URL);

export function* fetchOfertaFuncion(params) {
    try {
        let body = {};
        let endpoint = '';
        let nuevoToken = params.payload.trackId;
        let nuevoEmail = '';

        if ('trackId' in params.payload) {
            endpoint = 'evaluacion/consulta/oferta'
        }

        if ('infoFormulario' in params.payload && 'verificacionInfo' in params.payload) {
            const { formularioDatosPersonales, formularioTrabajadorDependiente, checkBoxValue } = params.payload.infoFormulario;
            const { nombreEmpleador, rutEmpleador, codigoTipoContrato, token } = params.payload.verificacionInfo;
            nuevoToken = token;

            const { email,numeroDeCelular,pais, region, comuna, buscarSucursalCercana} = formularioDatosPersonales[0];
            const { tiempoTrabajando, rutDependiente, cuantoGanaAlMes, contrato, cargo } = formularioTrabajadorDependiente[0];
            nuevoEmail = email;
            endpoint = 'evaluacion/oferta';

            const limpiarMonto = cuantoGanaAlMes.replaceAll('.','');
            const rutSinDot = rutDependiente.replaceAll('.','');
            const rutSinGion = rutSinDot.replaceAll('-','');
                
            body = {
                "antiguedadLaboral": tiempoTrabajando ? parseInt(tiempoTrabajando, 10) : params.payload.verificacionInfo.antiguedad,
                "celular": numeroDeCelular ,
                "codigoTipoContrato": contrato === ''? codigoTipoContrato: contrato ,
                "email": email ,
                "nombreEmpleador": nombreEmpleador,
                "pais": pais === 'CL'? 'CHILE': pais,
                "rentaLiquida": limpiarMonto,
                "rutEmpleador": rutDependiente === ''? rutEmpleador : rutSinGion,
                "tipoTrabajador": checkBoxValue === 'trabajador'? 'DEPENDIENTE' : 'INDEPENDIENTE',
                "codCargo": cargo,
                "codRegion": region,
                "codComuna": comuna,
                "buscarSucursalCercana" : buscarSucursalCercana            
            }
        }

        const optionalsHeaders = {
            'track_id': nuevoToken,
            'Authorization': `Bearer ${nuevoToken}`
        }

        yield put(loadersActions.changeStatusLoaderOferta({ isLoading: true }));

        const { data } = yield call(apiOferta.post, endpoint, body, optionalsHeaders);

        yield put(loadersActions.changeStatusLoaderOferta({ isLoading: false }));

        if (data && 'code' in data && data.code !== 1) {
            yield put(ofertaActions.ofertaCorrecto({ responseOferta: data, requestOferta: { email: nuevoEmail } }));
        } else if (data && data.code === 1) {
            yield put(ofertaActions.ofertaError({ responseValidar: data }));
        } else {
            yield put(ofertaActions.ofertaError({ responseValidar: { code: -1 } }));
        }
    } catch {
        yield all([
            put(ofertaActions.ofertaError({ responseValidar: {} }))
        ]);
    }
}

export function* watchFetchOferta() {
    yield takeLatest(ofertaActions.ofertaCreate.type, fetchOfertaFuncion);
}

export default function* rootSaga() {
    yield spawn(watchFetchOferta);
}
